module.exports = __webpack_public_path__ + "assets/mp3/audio9/lesson_2_04_audio2.mp3";